import axios from "axios";

export default {
  namespaced: true,
  state: {
    glposts: [],
    query: {},
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    glpostsMessage: ''
  },
  mutations: {
    DO_NOTHING(state) {
      state.isReceiving = false;
      state.isDeleting = false;
    },
    SET_QUERY(state, payload) {
      state.query = Object.assign({}, payload);
    },
    RECEIVED_GLPOSTS(state, payload) {
      state.glposts = payload;
      state.isReceiving = false;
    },
    RECEIVED_GLPOST(state, payload) {
      let find = state.glposts.find(i=>i._id==payload._id);
      state.isReceiving = false;
      if(find==null){
        state = Object.assign(state, { glposts: [payload, ...state.glposts] });
      }
      else {
        let index = state.glposts.findIndex(x => x._id === payload._id);
        state.glposts.splice(index, 1, payload);
      }
    },
    RECEIVING_GLPOSTS(state) {
      state.isReceiving = true;
    },
    RECEIVING_GLPOST(state) {
      state.isReceiving = true;
    },


    UPDATED_GLPOST(state, payload) {
      let index = state.glposts.findIndex(glpost => glpost._id === payload._id);
      state = Object.assign(state, {
        glposts: state.glposts.map((glpost, i) => {
          if (i === index) {
            return Object.assign({}, glpost, payload);
          }
          return glpost;
        }),
        isUpdating: false,
        glpostsMessage: 'GLPosts has been updating!',
      })
    },
    UPDATING_GLPOST(state) {
      state.isUpdating = true;
    },
    DELETED_GLPOST(state, payload) {
      let index = state.glposts.findIndex(i=>i._id == payload._id);
      let glposts = [...state.glposts];
      glposts.splice(index, 1);
      state = Object.assign(state, {
        glposts: [...glposts],
        isReceiving: false,
      });
    },
    DELETING_GLPOST(state, payload) {
      state.isReceiving = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async getGLPostsRequest({dispatch}) {
      dispatch("receivingGLPosts");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/gl-posts';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      let response = await axios({method: "GET", url: url, headers: headers});
      dispatch("receiveGLPosts", response.data);
      return response.data;
    },
        async getGLPostRequest({dispatch}, id) {
      dispatch("receivingGLPosts");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/gl-post/' + id;
      console.log(url)
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      let response = await axios({method: "get",url: url,headers: header});
      dispatch("receiveGLPost", response.data);
      console.log(response.data)
      return response.data;
    },
    async findGLPostsRequest({dispatch}, payload) {
      try{
        dispatch("receivingGLPosts");
        dispatch("setQuery", payload);
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/find/gl-posts';
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        dispatch("receiveGLPosts", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateGLPostRequest({dispatch}, payload) {
      dispatch("updatingGLPost");
      let id = payload._id;
      delete payload['_id'];

      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/gl-post/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      return axios({method: "PUT",url: url,headers: headers,data: payload})
      .then(function (res) {
        dispatch("updateGLPost", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    async updateGLPostTransaction({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let id = payload._id;
        delete payload['_id'];
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/gl-transaction/' + id;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        dispatch("doNothing");
        return response.data;
      }
      catch(e){
        console.log(e)
        return null;
      }
    },
    async updateGLPostSendRequest({dispatch}, payload) {
      dispatch("updatingGLPost");
      var id = payload._id;
      delete payload['_id'];
      var token = localStorage.getItem('token');
      var url = 'https://api.tradexc.com:3000/update/gl-post/send/' + id;
      var header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      let response = await axios({method:"put", url:url, headers:header, data:payload})
      dispatch("updateGLPost", response.data);
      return response.data;
    },
    async insertGLPostRequest({dispatch}, payload) {
      dispatch("receivingGLPosts");
      let token = localStorage.getItem('token');
      console.log(token)
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      let url = 'https://api.tradexc.com:3000/insert/gl-post';
      let data = payload;

      let response = await  axios({method: "POST", url: url, headers: headers, data: data});
      dispatch("receiveGLPost", response.data);
      return response.data;
    },
    async deleteGLPostRequest({dispatch}, payload) {
      dispatch("deletingGLPost", payload);
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/delete/gl-post/' + payload._id
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      let response = await axios({method: "DELETE", url: url, headers: headers});
      dispatch("deleteGLPost", response.data);
      return response.data;
    },
    doNothing({commit}) {
      commit("DO_NOTHING")
    },
    async setQuery({commit}, payload) {
      commit("SET_QUERY", payload);
    },
    receiveGLPosts({commit}, payload) {
      commit("RECEIVED_GLPOSTS", payload)
    },
    receivingGLPosts({commit}) {
      commit("RECEIVING_GLPOSTS")
    },
    receiveGLPost({commit}, payload) {
      commit("RECEIVED_GLPOST", payload)
    },
    receivingGLPost({commit}) {
      commit("RECEIVING_GLPOST")
    },
    updateGLPost({commit}, payload) {
      commit("UPDATED_GLPOST", payload)
    },
    updatingGLPost({commit}) {
      commit("UPDATING_GLPOST")
    },
    deleteGLPost({commit}, payload) {
      commit("DELETED_GLPOST", payload)
    },
    deletingGLPost({commit}, payload) {
      commit("DELETING_GLPOST", payload)
    }
  },
};
